/**
 * Oct 14 "something to talk about" copy pass (TEST). Applied last inside
 * withPinnedLandingCopy so these win over older pins. Pricing/policy text untouched.
 * Not therapy. No heavy topics.
 */
import { SESSION_TOPIC_LABELS } from './sessionTopics';

const labels = Object.fromEntries(
  Object.entries(SESSION_TOPIC_LABELS).map(([id, label]) => [`SessionTopics.${id}`, label])
);

export const INTEREST_COPY = {
  ...labels,
  'SessionTopics.groupTopics': 'Life topics',
  'SessionTopics.groupInterests': 'Interests',
  'LandingPage.featuredEmpty':
    'No featured listeners right now. Browse by what you want to talk about: your team, your show, your pets, or work.',
  'ContentPage.about.lede':
    'Sweet Listeners is someone to talk to, and something to talk about. It’s like your favorite group chat or forum, just one-on-one with a friendly listener who’s into the same thing.',
  'ContentPage.howItWorks.step1Body':
    'Pick what you want to talk about, like your team, a show you’re bingeing, your pets, or venting about work. Then choose a verified adult listener who loves it too. Search is by name or interest, not by street or neighborhood.',
  'ContentPage.howItWorks.step3Body':
    'Join the way you chose: chat, voice or video. It’s like a group chat or forum about the thing you love, just one-on-one, with no audience. No crowd, no comments, nothing public. Speak your mind freely, and keep even world events or AI talk civil, without the social media pile-on.',
  'SearchPage.noResults':
    'No listeners matched that yet. Try another interest, like Sports, Pets or TV & movies, or clear the filters.',
  'SearchFiltersMobile.noResults': 'No listeners matched. Try another interest or topic.',
  'KeywordSearchBar.placeholder': 'A name, a team, a show, or what’s on your mind',
  'TopicSearchBar.label': 'Topics & interests',
  'TopicSearchBar.placeholder': 'Choose topics or interests',
  'TopicSearchBar.menuLabel': 'Topics & interests',
  'TopicPicker.legend': 'Topics & interests',
  'TopicPicker.placeholder': 'Choose topics or interests',
  'TopicPicker.menuLabel': 'Topics & interests',
  'TopicPicker.required': 'Pick at least one topic or interest to continue.',
  'TopicPicker.listenerLegend': 'What do you love to chat about?',
  'TopicPicker.listenerHint':
    'Only pick topics you’re confident and comfortable talking about. Be specific: talkers search for “Sports”, “Pets” or “Netflix & binge-worthy shows” and find you.',
  'TopicPicker.talkerLegend': 'What do you like to talk about?',
  'TopicPicker.talkerHint':
    'Optional. We only use this to suggest listeners who share your interests. It’s never shown on a public profile.',
  'ProfileEditFields.listeningTopics': 'What do you love to chat about? Life topics + interests',
  'ProfileEditFields.talkingTopics':
    'What do you like to talk about? (optional, private: only used to suggest listeners)',
  'BookingForm.topicsToday': 'What do you want to talk about today? (optional)',
  'BookingForm.topicsTodayHint':
    'This listener’s favorites are first. Pick anything else that’s on your mind.',
  'BookingForm.topicsTodayMore': '+ Something else',
  'BookingForm.topicsTodayLess': 'Show fewer',
  'OnboardingPage.listenProfileLede':
    'Finish your profile and publish it so talkers can find you. Add the things you love to chat about, like your team, your shows or your pets. Talkers search by these.',
  'OnboardingPage.talkProfileLede':
    'Private, with no public reviews. Add what you like to talk about and we’ll suggest listeners who are into it too.',
};
